<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
  <div fxFlex fxGrow="0">
    <mat-icon style="display: block;">{{icon}}</mat-icon>
  </div>
  <div fxFlex>
    <span>{{data.message}}</span>
  </div>
</div>
